import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';

@Component({
  selector: 'app-searchable-filter',
  standalone: true,
  imports: [FormsModule, CommonModule, ClickOutsideDirective],
  templateUrl: './searchable-filter.component.html',
  styleUrl: './searchable-filter.component.scss',
})
export class SearchableFilterComponent implements OnChanges {
  private cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) filterBy!: string;
  @Input({ required: true }) filterByOptions!: {
    option: string;
    value: string;
  }[];
  @Input() label = 'Filter by:';
  @Input() disabled = false;
  @Input() placeholder = 'Select...';

  @Output() filterByChanged = new EventEmitter<string>();

  isDropdownOpen = false;
  searchValue = '';
  filteredOptions: { option: string; value: string }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterByOptions'] && changes['filterByOptions'].currentValue) {
      this.filteredOptions = [...changes['filterByOptions'].currentValue];
    }
  }

  get selectedLabel(): string {
    if (!this.filterBy) {
      return this.placeholder;
    }
    const found = this.filterByOptions.find((o) => o.value === this.filterBy);
    return found ? found.option : this.placeholder;
  }

  toggleDropdown(): void {
    if (this.disabled) return;
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.searchValue = '';
      this.filteredOptions = [...this.filterByOptions];
    }
  }

  onSearch(value: string): void {
    const search = value.trim().toLowerCase();
    if (!search) {
      this.filteredOptions = [...this.filterByOptions];
      return;
    }
    this.filteredOptions = this.filterByOptions.filter((opt) =>
      opt.option.toLowerCase().includes(search),
    );
  }

  onSelectOption(value: string): void {
    this.filterBy = value;
    this.filterByChanged.emit(value);
    this.isDropdownOpen = false;
    this.searchValue = '';
  }

  onClickOutside(): void {
    this.isDropdownOpen = false;
    this.searchValue = '';
    this.cdr.detectChanges();
  }
}
